module.exports = __webpack_public_path__ + "static/media/angola.ad03bc6e.png";